'use strict';

var React = require("react");
var ReactDOM = require("react-dom");

var Tools = require('../../deploynaut/js/tools.jsx');

var StackCreator = require('./StackCreator.jsx');
Tools.install(StackCreator, 'StackCreator');

var CreateProjectProgress = require('./create_project_progress.jsx');
var createProjectProgressHolder = document.getElementById('create-project-progress-holder');
if(createProjectProgressHolder) {
	ReactDOM.render(
		<CreateProjectProgress
			isVirtual={isVirtual}
			statusUrl={createProjectStatusUrl}
			deployKey={deployKey}
			deployKeyTestUrl={deployKeyTestUrl}
			initalCanAccessRepo={canAccessRepo}
			gitUrl={gitUrl}
			repoInterface={repoInterface}
			editFormUrl={editFormUrl} />,
		createProjectProgressHolder
	);
}

